// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.root-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1 1;
  background-color: #011029;
  min-height: calc(100vh - 64px);
  width: 100%;
  margin-top: 64px;
  display: flex;
  flex-direction: column;
}

.management-container {
  padding: 2rem;
  background-color: #011029;
  min-height: calc(100vh - 64px);
  width: 100%;
  margin-top: 64px;
}`, "",{"version":3,"sources":["webpack://./src/components/layout/RootLayout.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,yBAAyB;EACzB,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;AAClB","sourcesContent":[".root-layout {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.main-content {\n  flex: 1;\n  background-color: #011029;\n  min-height: calc(100vh - 64px);\n  width: 100%;\n  margin-top: 64px;\n  display: flex;\n  flex-direction: column;\n}\n\n.management-container {\n  padding: 2rem;\n  background-color: #011029;\n  min-height: calc(100vh - 64px);\n  width: 100%;\n  margin-top: 64px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
